module.exports = __webpack_public_path__ + "media/images/athletes/3695-95be466595932789791a9633700f5efd.png";